<template>
  <div class="bg-indigo-600 px-16">
    <ul class="tabbed-menu horizontal theme--brand max-w-5xl mx-auto">
      <li class="tabbed-menu__item">
        <RouterLink :to="{ name: 'accounts.campaigns.show' }" class="tabbed-menu__link" exact>
          {{ $t('general') | capitalize }}
        </RouterLink>
      </li>
      <li class="tabbed-menu__item">
        <RouterLink
          v-if="$membershipHasPermissionTo('read pages')"
          :to="{ name: 'accounts.campaigns.googleAnalytics' }"
          class="tabbed-menu__link"
        >
          Analytics
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ProductTabbedMenu',
};
</script>
